<template>
  <div>
    <QueryFrame @handlePage='handlePage' @handlePageSize='handlePageSize' :count='count' :disablePage='disablePage' :current="page">
      <div slot="queryParams" class="form">
        <div class="info">
          <div>供应商编码:{{$route.params.code}}</div>
          <div>
            <span>
              供应商名称:{{$route.params.name}}
            </span>
            <span>
              社会统一信用代码:{{$route.params.socialCode}}
            </span>
          </div>
        </div>
        <div class="queryContainer">
          <!-- <div class="queryItem">
            <label style="width:">店面名称:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable v-model.trim='query.storeName'></lk-input>
          </div> -->
           <div class="queryItem" v-if="roleType!==2">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>

          <div class="queryItem">
            <label style="width:">首营审批状态:</label>
            <lk-select clearable placeholder=" 请选择" class="item" v-model.trim='query.auditStatus'>
              <lk-option v-for="(item,index) in aduitList.slice(1)" :value='index+1' :key="index">{{item}}</lk-option>
              </lk-select>
          </div>
          <div class="queryItem">
            <label style="width:">启用状态:</label>
            <lk-select clearable placeholder=" 请选择" class="item" v-model.trim='query.status'>
              <lk-option v-for="(item,index) in status" :value='index+1' :key="index">{{item}}</lk-option>
              </lk-select> </div>
          <div class="queryItem">
            <label style="width:">首营申请号:</label>
            <lk-input :maxlength='100' class="item" clearable v-model.trim='query.applyCode'>

            </lk-input>
          </div>
          <div class="queryItem">
            <label style="width:">引用人:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable v-model.trim='query.createUserName'></lk-input>
          </div>
          <div class="queryItem">
            <label style="width:">引用时间:</label>
            <timeStampDatePicker placeholder='请输入' class="item" clearable v-model.trim='query.createTimeStartMs'></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch(true)">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns='columns' :data='tableData'></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '../../../components/frame/QueryFrame.vue';
import utils from '../../../libs/utils';
import supplier from '../../../services/supplier';
// import system from '../../../services/system';
import mapState from '../../../mixins/mapState'; // 鉴权
import queryMixins from '../../../mixins/queryMixins';

export default {
  name: 'SupplierGeneralFirstList',
  mixins: [mapState, queryMixins],
  components: { QueryFrame },
  data() {
    return {
      storeList: [],
      status: ['启用', '禁用'],
      aduitList: ['', '草稿', '审核中', '审核通过', '审核驳回'],
      disablePage: false,
      params: {
        // storeName: '',
        // memoryCode: '',
        // code: '',
        createTimeStart: '',
        auditStatus: '',
        status: '',
        applyCode: '',
        createUserName: '',
        createTimeStartMs: null,
        storeIdList: [],

      },
      query: {
        storeIdList: [],
        // storeName: '',
        // memoryCode: '',
        // code: '',
        createTimeStartMs: null,
        createTimeStart: '',
        auditStatus: '',
        status: '',
        applyCode: '',
        createUserName: '',
      },
      columns: [
        // { title: '门店ID', key: 'storeInfoId', minWidth: 116 },
        { title: '店面名称', key: 'storeInfoStoreName', minWidth: 116 },
        { title: '首营审批状态', key: 'storeInfoFlowStatus', minWidth: 116 },
        { title: '供应商在店状态', key: 'storeInfoStatus', minWidth: 116 },
        { title: '申请单号', key: 'storeInfoBillCode', minWidth: 116 },
        { title: '引用人', key: 'storeInfoCreateUserName', minWidth: 116 },
        { title: '引用时间', key: 'storeInfoCreateTime', minWidth: 116 },

        {
          title: '操作',
          width: 130,
          fixed: 'right',
          key: 'action',
          render: (h, params) => h('div', [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  // console.log(this.$route.params);
                  this.$route.params.storeId = params.row.storeInfoId;
                  this.$router.push({ name: 'supplierGeneralFirstInfo', params: this.$route.params });
                },
              },
            }, '查看'),

          ]),
        },
      ],
      tableData: [],
    };
  },
  computed: {
    roleType() {
      // roleType: state => state.user.roleType
      return this.$store.state.user.roleType;
    },
  },
  methods: {
    // getStoreList() {
    //   system.getBelongStores().then((res) => {
    //     if (res.data.status === 200) {
    //       this.storeList = [];
    //       res.data.data.forEach((item) => {
    //         this.storeList.push(item);
    //       });
    //     } else {
    //       this.$Message.error(res.data.error);
    //     }
    //   }).catch((err) => {
    //     utils.handleError(err);
    //   });
    // },
    clear() {
      this.query = {
        // storeName: '',
        // memoryCode: '',
        storeIdList: [],
        // code: '',
        createTimeStart: '',
        flowStatus: '',
        status: '',
        applyCode: '',
        createTimeStartMs: null,
        createUserName: '',
      };
    },
    // handleSearch() {
    //   this.params = Object.assign(this.params, this.query);
    //   this.handlePage(1, true);
    // },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      // this.params.roleType = this.$store.state.user.roleType;// 区分门店角色还是总部角色
      // if (this.params.createTimeStartMs) {
      //   this.params.createTimeStartMs = (new Date(this.params.createTimeStartMs).getTime());
      //   this.params.createTimeEndMs = (new Date(this.params.createTimeStartMs).getTime());
      // }
      if (`${this.params.status}`) {
        this.params.statusCodeList = [this.params.status];
      }
      this.params.supplierBaseId = this.$route.params.id;
      supplier.SupplierStoreList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          // console.log(res.data);
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.createTimeStart = utils.exchangeTime(result.createTimeStart);
            result.storeInfoFlowStatus = this.aduitList[result.storeInfoFlowStatus];
            // console.log(result);
            result.loading = false;
            result.storeInfoStatus = this.status[result.storeInfoStatus - 1];
            result.storeInfoCreateTime = utils.exchangeTimeToSecond(result.storeInfoCreateTime);
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // handlePage(page, isSearch) {
    //   this.page = page;
    //   if (isSearch) {
    //     this.disablePage = true;
    //     this.$nextTick(() => {
    //       this.disablePage = false;
    //       this.size = 10;
    //       this.getData();
    //     });
    //   } else {
    //     this.getData();
    //   }
    // },
    // handlePageSize(size) {
    //   this.size = size; this.page = 1;
    //   this.getData();
    // },
  },
  mounted() {
    if (!this.handlePermission('supplierGeneralFirstInfo')) {
      this.columns = this.columns.slice(0, this.columns.length - 1);
    }
    // this.getStoreList();
    // this.getData();
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
.info{
div:first-child{
  font-weight: bold
}
  div:last-child {
    margin-bottom: 16px;
      span{
      margin-right: 18px;

    }
  }
}
</style>
